import { get } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/home/id/116?pretty
export const home = async() => {
  return get(`home`)
}